import script from "./VvicItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./VvicItem.vue?vue&type=script&setup=true&lang=ts"

import "./VvicItem.vue?vue&type=style&index=0&id=7c323e88&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c323e88"]])

export default __exports__